<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [appearance]="'compact'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.compact"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center h-20 mt-3 mb-4">
            <a href="/home">
            <img
                class="w-10"
                src="/assets/logo/logo.png"
                alt="Logo image">
                </a>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <!-- <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        
        
    </div> -->


    <!-- addeddddddd by ibrahim -->
<div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">

    <!-- Navigation toggle button -->
    <button
        type="button"
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')"
        title="Open navigation">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>

    <!-- Logout button -->
    <button
        type="button"
        mat-icon-button
        class="ml-auto text-red-600"
        (click)="logout()"
        title="Logout">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'">
        </mat-icon>
    </button>

</div>


    <!-- Content -->
    <div class="flex flex-col flex-auto" style="width: 100%">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet></router-outlet>
    </div>

    <!-- Footer -->
    <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">TrueTech &copy; {{currentYear}}</span>
    </div>

</div>

<!-- Quick chat -->
